import React from 'react';

import type { ButtonBaseProps } from '@mui/material';
import { ButtonBase, Typography } from '@mui/material';
import clsx from 'clsx';
import { useEditorLoading } from 'src/layout-engine';

import { ToolbarSelectArrowIcon, useToolbarSelectStyles } from './ToolbarSelect';

export interface ToolbarMenuTriggerProps extends ButtonBaseProps {
  open: boolean;
}

/**
 * A button-based version of ToolbarSelect, suitable for use on toolbar items that do not require
 * editable inputs.
 */
export function ToolbarMenuTrigger({
  children,
  className,
  open,
  ...props
}: ToolbarMenuTriggerProps) {
  const editorLoading = useEditorLoading();
  const { classes } = useToolbarSelectStyles({ border: true, disabled: editorLoading, open });

  return (
    <ButtonBase {...props} className={clsx(classes.select, className)}>
      <Typography className={classes.text}>{children}</Typography>
      <ToolbarSelectArrowIcon />
    </ButtonBase>
  );
}
